export const getAssignedServiceIds = (profile) => {
  const ids = (Array.isArray(profile?.serviceUnits) ? profile.serviceUnits : [])
    .map((service) => Number(service?.id ?? service))
    .filter((id) => Number.isInteger(id) && id > 0);
  const primaryId = Number(profile?.serviceUnit?.id ?? profile?.serviceUnit);
  if (Number.isInteger(primaryId) && primaryId > 0) ids.push(primaryId);
  return [...new Set(ids)];
};
